import { Navigate } from 'react-router-dom';
import { useOrgPaths } from '@/hooks/useOrgPaths';

/** Legacy `/club-payments` → membership page (payment history lives there). */
export function OrgClubPaymentsRedirect() {
  const { p } = useOrgPaths();
  const target = p('/membership');
  if (!target) return null;
  return <Navigate to={target} replace />;
}
